import { render } from "./ReserveTicketConfirm.vue?vue&type=template&id=33935977&scoped=true"
import script from "./ReserveTicketConfirm.vue?vue&type=script&lang=js"
export * from "./ReserveTicketConfirm.vue?vue&type=script&lang=js"

import "./ReserveTicketConfirm.vue?vue&type=style&index=0&id=33935977&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33935977"]])

export default __exports__